import { Decimal } from '@insio/decimal';
import { DocumentExchangeRateSource, type IDocumentExchangeRate } from '@insio/shared-types';

function clean(value: IDocumentExchangeRate): IDocumentExchangeRate {
  return {
    rate: new Decimal(value.rate),
    source: value.source,
    externalSource: value.externalSource ?? null,
    rateDate: value.rateDate ?? null
  };
}

/**
 * Resolves the exchange rate object to save: preserves provenance when the
 * numeric rate is unchanged, echoes an accepted suggestion (EXTERNAL), and
 * otherwise marks the rate as MANUAL.
 */
export function resolveExchangeRateValue(
  finalRate: Decimal | null,
  current: IDocumentExchangeRate | null | undefined,
  suggested?: IDocumentExchangeRate | null
): IDocumentExchangeRate | null {
  if (finalRate === null) return null;
  if (current?.rate != null && finalRate.eq(current.rate)) return clean(current);
  if (suggested?.rate != null && finalRate.eq(suggested.rate)) return clean(suggested);
  return { rate: finalRate, source: DocumentExchangeRateSource.MANUAL };
}
